import { Protocol } from '../Protocol';

export class ExperimentResultTypeProtocol {
  public static readonly EXPERIMENT_RESULT_TYPES_BY_SEARCH: string = `${Protocol.YATUNG_API_ROOT}/expt/resultType/search`;
}
